// generated from 6 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const hasAdTrackingEnabledFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("has_ad_tracking_enabled_filter"),
  comparison_key: z.literal("1"),
  display_name: z.string(),
  // undefined: 4 (66.67%), defined 2 (33.33%)
  raw_value: z.literal(true).optional(),
  value: z.literal(true),
  varies_by_app_group: z.literal(false),
});
